import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const EstimatorContext = createContext(null);

export const EstimatorProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [preselect, setPreselect] = useState(null);

  const openEstimator = useCallback((preselectType = null) => {
    setPreselect(preselectType);
    setIsOpen(true);
  }, []);

  const closeEstimator = useCallback(() => {
    setIsOpen(false);
    setPreselect(null);
  }, []);

  // Memoized so consumers only re-render when state actually changes.
  const value = useMemo(
    () => ({ isOpen, preselect, openEstimator, closeEstimator }),
    [isOpen, preselect, openEstimator, closeEstimator]
  );

  return <EstimatorContext.Provider value={value}>{children}</EstimatorContext.Provider>;
};

export const useEstimator = () => {
  const ctx = useContext(EstimatorContext);
  if (!ctx) throw new Error('useEstimator must be used within EstimatorProvider');
  return ctx;
};
